import SearchIcon from '@material-ui/icons/Search';
import * as React from 'react';
import styled from 'styled-components';

type FieldType = 'email' | 'text' | 'textarea' | 'search';

interface IProps {
  name: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  value: string;
  type?: FieldType;
  label?: string;
  className?: string;
  rows?: number;
  errorMessage?: string;
  nomargin?: boolean;
  placeholder?: string;
  textFieldClassName?: string;
}

export const TextField: React.SFC<IProps> = props => {
  const fieldType = props.type || 'text';

  const field =
    props.type === 'textarea' ? (
      <TextArea
        name={props.name}
        onChange={props.onChange}
        value={props.value || (props.placeholder || '')}
        rows={props.rows || 4}
        className={props.textFieldClassName}
      />
    ) : props.type === 'search' ? (
      <SearchContainer>
        <Input
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          className={props.textFieldClassName}
          placeholder={props.placeholder}
        />
        <Icon />
      </SearchContainer>
    ) : (
      <Input
        name={props.name}
        type={fieldType}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        className={props.textFieldClassName}
      />
    );
  return (
    <Container
      className={props.className}
      style={props.errorMessage ? { color: 'red' } : {}}
      nomargin={props.nomargin}
    >
      {props.label && <Label>{props.label}</Label>}
      {field}
      {props.errorMessage && <Error>{props.errorMessage}</Error>}
    </Container>
  );
};

const Container = styled.div<{ nomargin?: boolean }>`
  margin-bottom: ${p => (p.nomargin ? '0' : '15px')};
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border-radius: 3px;
  border: 1px solid hsl(0, 0%, 80%);
  @media (max-width: 900px) {
    font-size: 14px;
    padding: 8px;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 15px;
  @media (max-width: 900px) {
    font-size: 14px;
    padding: 8px;
  }
`;

const Label = styled.div`
  margin-bottom: 10px;
  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

const Error = styled.div`
  font-size: 14px;
`;

const Icon = styled(SearchIcon)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

const SearchContainer = styled.div`
  ${Input} {
    padding: 8px;
    padding-right: 18px;
  }
  position: relative;
`;

export default TextField;



// WEBPACK FOOTER //
// ./src/components/TextField/TextField.tsx